import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import Autocomplete from "../../elements/Select/Autocomplete";
import * as actions from "../../store/actions";

const SkillDropDown = ({selectedData = [], handleChange}) => {
    const dispatch = useDispatch()

    const {skills} = useSelector((state) => {
        return {
            skills: state?.skills?.skills || [],
        }
    });

    useEffect(() => {
        dispatch(actions.getSkills())
    }, [])

    return (
        <Autocomplete
            data={skills}
            displayLabel={"name"}
            multiple={true}
            selectedData={selectedData}
            equalKey={"slug"}
            minWidth={"auto"}
            onChange={handleChange}
            inputProps={{
                type: "text",
                title: "Skills",
                variant: "outlined",
                placeholder: "Skills",
                autoFocus: true,
                noMargin: true,
                InputProps: {
                    style: {minHeight: 45}
                },
                InputLabelProps: {
                    shrink: false,
                },
                size: "small"
            }}
        />
    )
}

export default SkillDropDown;
